import { getQueryKeys } from "../../helper";

const namespace = "rates";

export default {
  ...getQueryKeys(namespace),
};
